import createCollectionStoreClass from './lib/create_collection_store_class';
import UserConverter from '../immutable_converters/user_converter';

var UsersStore = createCollectionStoreClass({
  converter: UserConverter,
});

export default UsersStore;



// WEBPACK FOOTER //
// ./src/scripts/adapters/stores/users_store.js